<template>
    <div class="home">
        <v-layout align-start justify-center row class="mt-4">
            <img src="img/logo-easyfert-compact.svg" alt="logo" />
        </v-layout>
        <v-layout justify-center column xs12 class="mt-2">
            <p class="mt-2 txt-center" style="font-size: 12px">
                {{ $t("home_baseline") }}
            </p>
            <p class="petit txt-center" style="margin-top: -1.3em">{{ $t('home_donneesComifere') }}</p>
        </v-layout>
        <v-layout row xs12 justify-center class="mt-2">
            <p class="w-75 txt-center" style="font-size: 12px">
                {{ $t("home_baseline2") }}
            </p>
        </v-layout>
            <v-layout align-start justify-center row class="mt-2">
                <span style="line-height: 36px;">{{ $t('home_choixTypeApplication') }}</span><a href="#/aide/1067" style="text-decoration: none;"><v-icon large color="primary">info</v-icon></a>
            </v-layout>
            <v-layout align-start justify-center row class="mt-1">
                <img src="img/Epandeur-texte-haut-150x147.png" @click="goToEasyfert" alt="logo" style="cursor: pointer;" class="pr-1" />
                <img src="img/Pulvérisateur-texte-haut-150x147.png" @click="goToEpso" alt="logo" style="cursor: pointer;" class="pl-1" />
            </v-layout>
    </div>
</template>

<script>
export default {
  data() {
    return {
      name: "Home"
    };
  },
  methods: {
    goToEasyfert() {
        this.$store.dispatch('updateRoutes', this.$router.currentRoute.path).then(
            () => {
                this.$router.push({ path: 'rendement' }); // on change de page
            },
            () => {
                console.error("Erreur de routage ")
            }
        )
    },
    goToEpso() {
        window.location.href = '/epso/dist/index.html#/objectif'; 
    },
    goToPremium () {
      // L'aiguillage est différent si on est en démo ou prod
      if(window.location.hostname.indexOf("easyfert.fr") !== -1) {
        window.location.href = 'https://www.easyfert.fr/premium/dist/'; 
      } else {
        window.location.href = 'https://demo-iah-kali-cms.isagri-ingenierie.fr/premium/dist/';
      }
    }
  },
  mounted() {
    this.$store.dispatch("razRoutes");
    this.$store.dispatch("razForms");
  }
};
</script>

<style scoped lang="scss"></style>
